import { LinkType } from '@ria-client/segment/enums';
import type { MarketplaceEntityForProductCardType as MarketplaceEntity } from '@ria-client/supergraph/structuredContent/hydration/MarketplaceProductCard/types';
import { TrackedLink } from '@ria-client/tw-shared-ui';
import Image from 'next/image';

export interface HeaderImageProps {
  marketplaceEntity: MarketplaceEntity;
}

export function HeaderImage({ marketplaceEntity }: HeaderImageProps) {
  const { cta, id, image, institution, monetizable, product, productType } = marketplaceEntity;

  return (
    <div className="flex justify-center">
      <TrackedLink
        analyticsPayload={{
          index: 0,
          institutionId: institution.id,
          offerId: id,
          productId: product.id,
          productType,
        }}
        cta={cta}
        linkType={LinkType.PRODUCT_IMAGE}
        monetizable={monetizable}
      >
        <div className="hidden sm:flex">
          <Image
            alt={image.alt}
            height={0}
            src={image.source}
            style={{ width: '221px', height: 'auto' }}
            width={221}
          />
        </div>
        <div className="flex sm:hidden">
          <Image
            alt={image.alt}
            height={0}
            src={image.source}
            style={{ width: '160px', height: 'auto' }}
            width={160}
          />
        </div>
      </TrackedLink>
    </div>
  );
}
